import React from 'react';

export default function (params = {}) {
  const {
    samples,
    CodeMirror,
    DropdownButton,
    MenuItem,
  } = params;
  return (
    <div className="container-fluid" styleName="root">
      <nav className="navbar navbar-default navbar-fixed-top" styleName="header">
        <div className="container-fluid">
          <div className="navbar-header">
            <a className="navbar-brand" href="https://github.com/bluewings/pug-as-jsx-loader">
              <i className="fa fa-fw fa-github-alt" />
              &nbsp;pug-as-jsx-loader
            </a>
          </div>
          <div className="navbar-collapse collapse" id="navbar">
            <ul className="nav navbar-nav">
              <li>
                <a href="#try-it-out">Try it out</a>
              </li>
              <li>
                <a href="#webpack-config-js">webpack.config.js</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="row" style={{ paddingTop: 10 }}>
        <div className="col-sm-12">
          <h2 styleName="topic">
            <div id="try-it-out" styleName="anchor" />
            <span>
              Try it out
              <a aria-hidden="true" className="header-anchor" href="#try-it-out">
                <span>¶</span>
              </a>
            </span>
          </h2>
        </div>
        <div className="col-sm-6" styleName="overflow-visible">
          <div className="panel panel-default" styleName={(this.state.err ? 'has-error': '')}>
            <div className="panel-heading">
              <i className="fa fa-fw fa-code" />
              &nbsp; try-it-out.pug
              <div className="pull-right">
                <DropdownButton bsSize="sm" id="samples" pullRight={true} title={this.state.sampleName}>
                  {(samples || []).map((sample, i) =>
                    <MenuItem eventKey={i} key={i} onClick={this.selectSample.bind(this, sample)}>
                      {sample.name}
                    </MenuItem>
                  )}
                </DropdownButton>
              </div>
            </div>
            <div className="panel-body" style={{ padding: 0 }}>
              <div styleName="code-wrap">
                <CodeMirror
                  onChange={this.handleSourceChange}
                  options={{ mode: 'pug', styleActiveLine: true, lineNumbers: true, lineWrapping: false, theme: 'default' }}
                  ref={(cm) => this.cm.source = cm}
                  value={this.state.source}
                />
              </div>
            </div>
            {(this.state.err) && (
            <div className="panel-footer">
              <pre>{this.state.err}</pre>
            </div>
            )}
          </div>
        </div>
        <div className="col-sm-6" styleName="overflow-visible">
          <div className="panel panel-default">
            <div className="panel-heading">
              <i className="fa fa-fw fa-file-text-o" />
              &nbsp; Result
            </div>
            <div className="panel-body" style={{ padding: '0 10px' }}>
              {(this.state.tab !== 'jsx') && (
              <div>
                <p styleName="tab">
                  Transpiled JSX
                  <span>&nbsp; | &nbsp;</span>
                  <a href="" onClick={this.selectTab.bind(this, 'jsx')}>Import PUG template</a>
                </p>
                <div styleName="code-wrap">
                  <CodeMirror
                    options={{ mode: 'jsx', styleActiveLine: false, lineNumbers: false, lineWrapping: false, theme: 'default', readOnly: true }}
                    ref={(cm) => this.cm.jsx = cm}
                    value={this.state.jsx}
                  />
                </div>
              </div>
              )}
              {(this.state.tab === 'jsx') && (
              <div>
                <p styleName="tab">
                  <a href="" onClick={this.selectTab.bind(this, 'usage')}>Transpiled JSX</a>
                  <span>&nbsp; | &nbsp;</span>
                  Import PUG template
                </p>
                <div styleName="code-wrap">
                  <CodeMirror
                    options={{ mode: 'javascript', styleActiveLine: true, lineNumbers: false, lineWrapping: false, theme: 'default', readOnly: true }}
                    ref={(cm) => this.cm.usage = cm}
                    value={this.state.usage}
                  />
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <hr />
          <h2 styleName="topic">
            <div id="webpack-config-js" styleName="anchor" />
            <span>
              webpack.config.js
              <a aria-hidden="true" className="header-anchor" href="#webpack-config-js">
                <span>¶</span>
              </a>
            </span>
          </h2>
        </div>
        <div className="col-sm-12" styleName="overflow-visible">
          <div className="panel panel-default">
            <div className="panel-heading">
              <i className="fa fa-fw fa-code" />
              &nbsp; webpack.config.js
            </div>
            <div className="panel-body" style={{ padding: 0 }}>
              <div styleName="code-wrap">
                <CodeMirror
                  options={{ mode: 'javascript', styleActiveLine: true, lineNumbers: true, lineWrapping: false, theme: 'default' }}
                  ref={(cm) => this.cm.webpackConfig = cm}
                  value={this.state.webpackConfig}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

//  /* USAGE EXAMPLE */
//  // Components
//  import CodeMirror from '__modulePath__/CodeMirror';
//  import DropdownButton from '__modulePath__/DropdownButton';
//  import MenuItem from '__modulePath__/MenuItem';
//
//  // jsx
//  import template from './Home.pug';
//
//  class Report extends React.Component {
//
//    render() {
//      const {
//        samples,
//      } = this;
//
//      return template.call(this, {
//        // variables
//        samples,
//        // components
//        CodeMirror,
//        DropdownButton,
//        MenuItem,
//      });
//    }
//
//  }
//  /* // USAGE EXAMPLE */



// WEBPACK FOOTER //
// ./src/app/screens/Home/Home.pug